<template>
  <div class="box vh-140">
    <div class="box-header">
      <i class="fa fa-th-large"></i>
      <h3 class="box-title">客户列表</h3>
    </div>
    <div class="box-body">
      <el-row class="margin-bottom-10" gutter="20">
        <el-col :span="18">
          <el-button type="primary" size="small" @click="toAdd()" plain><i class="fa fa-plus"></i> 添加客户</el-button>
        </el-col>
      </el-row>
      <el-table class="list-table" :data="list" border :stripe="true" style="width: 100%"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }">
        <template slot="empty">
          <div class="no-data">暂无数据！</div>
        </template>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + page.pageSize * (page.pageNo - 1) + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="客户名称" prop="name"></el-table-column>
        <el-table-column label="联系人" prop="contact"></el-table-column>
        <el-table-column label="联系电话" prop="phone"></el-table-column>
        <el-table-column label="地址" prop="address"></el-table-column>
        <el-table-column fixed="right" label="操作" width="300">
          <template slot-scope="scope">
            <el-button type="text" @click="toAdd(scope.row.id)" size="small"><i class="fa fa-edit"></i> 编辑</el-button>
            <el-button type="text" @click="toDelete(scope.row.id)" size="small"><i class="fa fa-trash"></i> 删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <page-bar v-model="page" @change="fetchData"></page-bar>
      <save :visible="addDialog" :id="id" @done="handleFinish"></save>
    </div>
  </div>
</template>

<script>
import { fetchList, remove } from "@/api/enterprise/customer";
import { mapGetters } from "vuex";
import PageBar from "@/components/PageBar.vue";
import Save from "./Save";
import { handleConfirm } from "@/utils/confirm";

export default {
  name: "customer-list",
  components: { PageBar, Save },
  computed: {
    ...mapGetters(["company"])
  },
  created() {
    this.fetchData();
  },
  data: function() {
    return {
      list: [],
      addDialog: false,
      id: null,
      page: {
        pageSize: 20,
        pageNo: 1
      }
    };
  },
  methods: {
    fetchData() {
      let { pageNo, pageSize } = this.page;
      fetchList(this.company.id, { pageNo, pageSize }).then(res => {
        this.page = res.data.result;
        this.list = res.data.result.records;
      });
    },
    toAdd(val=null) {
      this.id = val;
      this.addDialog = true;
    },
    toDelete(id) {
      handleConfirm("此操作将删除该维度, 是否继续?").then(() => {
        remove(id).then(resp => {
          this.$message.success(resp.data.message);
          this.fetchData();
        });
      });
    },
    handleFinish(flag = false) {
      this.addDialog = false;
      if (flag) {
        this.fetchData();
      }
    }
  }
};
</script>
